<ym-dialog (onClose)="closeDialog()">
    <!-- <ng-container header>Header</ng-container> -->
    <ng-container body>
        <div class="ym-display-flex ym-flex-direction-column ym-gap-3">
            <h3 class="ym-font-size-h2 ym-line-height-28">Are you sure you want to delete {{title}}?</h3>
            <p>This action is permanent and can't be undone.</p>
        </div>
    </ng-container>
    <ng-container actions>
        <ym-button [type]="buttonTypes.DANGER" (onClick)="onDeleteClick()">Delete</ym-button>
    </ng-container>
</ym-dialog>